import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TrechoExtrasSection({ formData, handleText, handleSelect }) {
  const { t } = useTranslation("products");

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("trechoForm.extrasTitle")}
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="aceitacarga-label">{t("trechoForm.acceptsCargo")}</InputLabel>
              <Select
                labelId="aceitacarga-label"
                label={t("trechoForm.acceptsCargo")}
                name="aceitacarga"
                value={Number(formData.aceitacarga) === 1 ? 1 : 0}
                onChange={handleSelect}
              >
                <MenuItem value={0}>{t("trechoForm.no")}</MenuItem>
                <MenuItem value={1}>{t("trechoForm.yes")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label={t("trechoForm.distanceKm")}
              name="distancia"
              value={formData.distancia}
              onChange={handleText}
              fullWidth
              placeholder={t("trechoForm.distancePlaceholder")}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label={t("trechoForm.notesLabel")}
              name="detalhes"
              value={formData.detalhes}
              onChange={handleText}
              fullWidth
              multiline
              minRows={2}
              placeholder={t("trechoForm.notesPlaceholder")}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
